/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
// import '../styles/css/payment-data.css';
import { Header, Grid } from 'semantic-ui-react';

class CreditCard extends Component {
  constructor() {
    super();
    this.state = {
      values: []
    }
  }
  
  render() {
    const { node, open, ach, creditCard, payPal } = this.state
    const data = this.props
    const style = {
      container: {
        borderRadius: 0,
      },
      radio: {
        fontWeight: '200 !important'
      }
    }

    return (
      <div>
        <div id={this.props.index} className="one-card creditCard" key={this.props.index} count={this.props.count}>
          <label className="payment-data-label" as="h8">{this.props.data.paymentType}</label>
          <Grid columns={2} divided className="card-grid">
            <Grid.Row>
              <Grid.Column>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <label className="payment-data-label">CARD HOLDER</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.cardHolder}</Header>
              </Grid.Column>
              <Grid.Column>
                <label className="payment-data-label">CARD NUMBER</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.cardNumber}</Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <label className="payment-data-label">CVV</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.CVV}</Header>
              </Grid.Column>
              <Grid.Column>
                <label className="payment-data-label">EXP DATE</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.expDate}</Header>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </div>
      </div>
    );
  }
}

export default CreditCard;
